<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Medical Room</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's Medical Room! Our medical room is a dedicated space where students can receive first aid and medical attention as needed during the school day. At our school, we take the health and safety of our students very seriously, and our medical room is an essential part of our commitment to ensuring a safe and healthy learning environment. We encourage all students and staff to use our medical room as needed and to prioritize their health and well-being.
                    </p>  
                    <p class="inner-lead">At our school, we believe that a healthy student is a happy student, and we are committed to promoting a culture of health and wellness. We encourage our students to prioritize their health and well-being, and we believe that this focus on health and wellness is essential to their success both in and out of the classroom.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>